// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1IOUW","location":"Header_location__1W_Hg"};